<template>
  <div class="fluid-grid">
    <div
      v-if="$slots.banner"
      class="z-48 span-full lg:top-[calc(var(--headerHeight)+var(--cvdNavigationHeight))]">
      <slot name="banner" />
    </div>
    <div
      class="fluid-grid z-49 span-full mt-4 bg-surface-base sm:top-16.5 lg:top-(--headerHeight)">
      <div class="span-popout space-y-8 xl:span-content">
        <CvdNavigation />
      </div>
    </div>
    <div class="fluid-grid span-full h-full bg-surface-base">
      <slot></slot>
      <DpaNewsSnackbar
        :hide-automatically="false"
        :icon="undefined"
        :show-snackbar="showSnackbar"
        :type="'success'"
        :action-label="t('generic.pageRefresh')"
        :action-callback="triggerReload">
        {{ t("generic.newCvDContent") }}
      </DpaNewsSnackbar>
    </div>
    <div class="span-full">
      <DpaNewsFooter
        :has-disclaimer="true"
        class="span-popout xl:span-content" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import CvdNavigation from "@/components/Cvd/CvdNavigation/CvdNavigation.vue";
import DpaNewsFooter from "@/components/shared/DpaNewsFooter/DpaNewsFooter.vue";
import DpaNewsSnackbar from "@/components/shared/DpaNewsSnackbar/DpaNewsSnackbar.vue";
import useCvDSocket from "@/composition/shared/sockets/useCvDSocket.ts";
import useCvdStore from "@/stores/cvd.ts";

const { startUpCvdSocket } = useCvDSocket();
const cvdStore = useCvdStore();

onMounted(startUpCvdSocket);
const { t } = useI18n();
const route = useRoute();

const triggerReload = () => {
  window.location.reload();
};

const showSnackbar = computed(() => {
  if (!route.params?.slug) {
    return false;
  }
  const slug =
    route.params.slug.length === 2
      ? route.params.slug[1]
      : route.params.slug[0];
  const currentPageId = cvdStore.slugToPageIdMap[slug];
  return cvdStore.updatedCvDPageIds.includes(currentPageId);
});
</script>
